<template>
  <v-dialog v-model="shown" width="700">
    <v-form>
      <v-card>
        <v-card-title class="mb-5 primary white--text">
          <h2 class="my-5">{{ location.id ? 'Update Location' : 'New Location' }}</h2>
        </v-card-title>
        <v-card-text>
          <v-textarea v-model="location.name" label="Location details" />
          <v-select
            v-model="location.group"
            hint="Assign this location to a group for the schedule grid view. (Optional)"
            persistent-hint
            :items="[{ text: 'Group 1', value: 'group-1' }, { text: 'Group 2', value: 'group-2'}, { text: 'Group 3', value: 'group-3' }]"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="shown = false"
            color="error"
            large
          >
            Cancel
          </v-btn>
          <v-btn
            @click="addOrUpdateLocation"
            color="accent"
            large
          >
            {{ location.id ? 'Update' : 'Submit' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  data: () => ({
    location: {
      name: '',
      group: 'group-1'
    },
    shown: false
  }),
  computed: {
    ...mapState(['firestore']),
    ...mapGetters(['allLocations'])
  },
  mounted () {
    this.$root.$on('showLocationEditor', (location) => {
      if (location) {
        this.location = JSON.parse(JSON.stringify(location))
      } else {
        this.location = {
          name: '',
          group: 'group-1'
        }
      }
      if (!this.location.group) this.location.group = 'group-1'
      this.shown = true
    })
  },
  methods: {
    ...mapMutations(['setGlobalNotification']),
    ...mapActions(['firestoreUpdateLocation', 'firestoreAddLocation']),
    async addOrUpdateLocation () {
      if (this.location.id) {
        console.log('Updating location', this.location)
        try {
          await this.firestoreUpdateLocation(this.location)
          this.setGlobalNotification({ val: 'Location updated.' })
        } catch (err) {
          console.log(err)
          this.setGlobalNotification({ val: 'Error updating location.', type: 'error' })
          return
        }
      } else {
        console.log('Saving new location', this.location)
        try {
          await this.firestoreAddLocation(this.location)
          this.setGlobalNotification({ val: 'Added new location.' })
        } catch (err) {
          console.log(err)
          this.setGlobalNotification({ val: 'Error adding new location.', type: 'error' })
          return
        }
      }
      this.location = {
        name: '',
        group: 'group-1'
      }
      this.shown = false
    }
  },
  watch: {
    shown (val) {
      if (!val) {
        this.location = {
          name: '',
          group: 'group-1'
        }
      }
    }
  }
}
</script>
